import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import Panel from 'components/Panel'
import {Button} from "../Button";
import {ModalSize, SimpleModal} from "../SimpleModal";
import {validateEmail} from "../../utils/validation";
import {Col, Row, Uppercase} from "../../styles/components";
import Form, {FormInitValuesType} from "../Form";
import * as S from './styles'

import FeedBackImage from '../../assets/images/ab_feedback_image.png'

const initValues: FormInitValuesType = {
    name: {value: '', validationCheck: (value) => value !== ''},
    email: {value: '', validationCheck: validateEmail},
    message: {value: '', validationCheck: value => value !== ''}
}

export const FAQ = () => {
    const intl = useIntl();

    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const closeModal = () => setShow(false);

    return (
        <S.Container>
            <S.Title><FormattedMessage id="faqTitle"/></S.Title>
            <S.SubText>
                <FormattedMessage id="faqSubText"/>
            </S.SubText>

            <Panel>
                <Panel.Header><FormattedMessage id="faqPanel1Title"/></Panel.Header>
                <Panel.Body>
                    <FormattedMessage id="faqPanel1Text"/>
                </Panel.Body>
            </Panel>

            <S.Br/>

            <Panel>
                <Panel.Header><FormattedMessage id="faqPanel2Title"/></Panel.Header>
                <Panel.Body>
                    <FormattedMessage id="faqPanel2Text"/>
                </Panel.Body>
            </Panel>

            <S.Br/>

            <Panel>
                <Panel.Header><FormattedMessage id="faqPanel3Title"/></Panel.Header>
                <Panel.Body>
                    <FormattedMessage id="faqPanel3Text"/>
                </Panel.Body>
            </Panel>

            <S.Br/>

            <Panel>
                <Panel.Header><FormattedMessage id="faqPanel4Title"/></Panel.Header>
                <Panel.Body>
                    <FormattedMessage id="faqPanel4Text"/>
                </Panel.Body>
            </Panel>

            <S.Br/>

            <Panel>
                <Panel.Header><FormattedMessage id="faqPanel5Title"/></Panel.Header>
                <Panel.Body>
                    <FormattedMessage id="faqPanel5Text"/>
                </Panel.Body>
            </Panel>

            <S.SupportBlock>
                <Row>
                    <Col xl={6} lg={6}>
                        <S.SupportTitle><FormattedMessage id="faqSupportTitle"/></S.SupportTitle>
                        <S.SupportText>
                            <FormattedMessage id="faqSupportText1"/>
                        </S.SupportText>
                        <Button onClick={showModal}>
                            <Uppercase><FormattedMessage id="faqSupportButton1"/></Uppercase>
                        </Button>
                    </Col>
                    <Col xl={5} lg={5}>
                        <S.Image src={FeedBackImage}/>
                    </Col>
                </Row>
            </S.SupportBlock>

            <SimpleModal show={show} close={closeModal} modalSize={ModalSize.medium}>
                <S.ModalBody>
                    <S.ModalTitle><FormattedMessage id="faqModalTitle"/></S.ModalTitle>

                    <Form initValues={initValues} apply={data => alert(JSON.stringify(data))}>
                        {
                            ({data, setValue, isValid, onSubmit}) => {
                                return (
                                    <div>
                                        <Form.Input
                                            name={'name'}
                                            placeholder={intl.formatMessage({id: "faqModalFIO"})}
                                            data={data}
                                            setValue={setValue}
                                            isValid={isValid['name']}
                                            hint={intl.formatMessage({id: "faqModalFIOHint"})}
                                        />

                                        <Form.Input
                                            name={'email'}
                                            placeholder={intl.formatMessage({id: "faqModalMail"})}
                                            data={data}
                                            setValue={setValue}
                                            isValid={isValid['email']}
                                            hint={intl.formatMessage({id: "faqModalMailHint"})}
                                        />

                                        <Form.TextArea
                                            name={'message'}
                                            placeholder={intl.formatMessage({id: "faqModalMessage"})}
                                            data={data}
                                            setValue={setValue}
                                            isValid={isValid['message']}
                                        />

                                        <Form.Submit onClick={onSubmit}>
                                            <Uppercase><FormattedMessage id="faqModalSubmitButton"/></Uppercase>
                                        </Form.Submit>
                                    </div>
                                )
                            }
                        }
                    </Form>
                </S.ModalBody>
            </SimpleModal>
        </S.Container>
    )
}